import { http } from '@/services/http_service';
export default{
    setViewPost(context,payload){
        // console.log('context',context);
        // console.log('payload',payload);
        if(!context.state.viewPost.some(viewPost => viewPost === payload))
        {
            context.commit("setViewPost", payload);
        }
    },
    fetchDocumentLists(context)//게시판종류 가져오기
    {
        return http()
        .get("/document/fetchLists")
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            context.commit('setDocuments', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },

}
